import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import { Tooltip, Toast, Popover } from 'bootstrap';
import "bootstrap";
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap-icons/font/bootstrap-icons.min.css"
import "./assets/css/index.scss"
import '@wangeditor/editor/dist/css/style.css' // 引入 css
import FooterCom from '@/layout/FooterCom.vue'
import NodataCom from "@/layout/NodataCom"
import LoadingCom from "@/layout/LoadingCom"
import PaginationCom from "@/components/PaginationCom" // 分页
import topBg from '@/layout/topBg.vue' // 顶部背景
const app = createApp(App)



// 全局使用的组件
app.component('FooterCom',FooterCom)
app.component('NodataCom',NodataCom)
app.component('LoadingCom',LoadingCom)
app.component('PaginationCom',PaginationCom)
app.component('topBg',topBg)
app.use(store).use(router).mount('#app')

// 重新bootstrap样式


